export function round(x: $TSFixMe) {
    return Math.floor(x);
}

export function roundTo5(x: $TSFixMe) {
    return Math.round(x / 5) * 5;
}

export function distance(x: $TSFixMe, y: $TSFixMe) {
    return Math.sqrt(x * x + y * y);
}

export function axisDistanceInvert(axis: $TSFixMe, index: $TSFixMe) {
    return axis.invert(index) - axis.invert(0);
}

export function getCenter(start: number, end: number) {
    return start + (end - start) / 2;
}
